/** Tải một URL về máy bằng thẻ <a> tạm thời. `filename` tuỳ chọn (chỉ có tác dụng với URL cùng origin / blob). */
export const downloadUrl = (url, filename) => {
  const link = document.createElement('a')
  link.href = url
  if (filename) link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/** Tải nhiều URL, giãn cách `gapMs` giữa các lần click để không bị chặn bởi download guard của trình duyệt. */
export const downloadUrls = (urls, gapMs = 300) => {
  urls.forEach((url, index) => setTimeout(() => downloadUrl(url), index * gapMs))
}

/** Tải dữ liệu trong bộ nhớ thành file (vd. GeoJSON). `data` là Blob hoặc chuỗi. */
export const downloadBlob = (data, filename, type = 'application/json') => {
  const blob = data instanceof Blob ? data : new Blob([data], { type })
  const url = URL.createObjectURL(blob)
  downloadUrl(url, filename)
  URL.revokeObjectURL(url)
}
